<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>© 2015 Ernest C. Lucas</p>
<p class="crt">All rights reserved</p>
<p class="crtf">Published 2015 by</p>
<p class="crt">Wm. B. Eerdmans Publishing Co.</p>
<p class="crt">2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /</p>
<p class="crt">P.O. Box 163, Cambridge CB3 9PU U.K.</p>
<p class="cipf"><b>Library of Congress Cataloging-in-Publication Data</b></p>
<p class="cipf">Lucas, Ernest.</p>
<p class="cip1">Proverbs / Ernest C. Lucas.</p>
<p class="cip2">pages cm. — (The two horizons Old Testament commentary)</p>
<p class="cip1">Includes <a class="xref" href="#/eerlucas0016#biblio">bibliographical references</a> and <a class="xref" href="#/eerlucas0017#ch03">index</a>.</p>
<p class="cip1">ISBN 978-0-8028-2710-4 (pbk.: alk. paper); 978-1-4674-4399-9 (ePub); 978-1-4674-4359-3 (Kindle)</p>
<p class="cip1">1. Bible. Proverbs — Commentaries. I. Title.</p>
<p class="cipf1">BS1465.53.L83 2015</p>
<p class="cip1">223′.707 — dc23</p>
<p class="cip2">2015021794</p>
<p class="crtf"><a class="url" href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-lucas-0004.vue?1f131e9c